
type Dictionary = {[key: string]: unknown};
type Mutator = (params: Dictionary) => Dictionary;

import VNode from "virtual-dom/vnode/vnode";
import VText from "virtual-dom/vnode/vtext";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const htmlToVdom = require('html-to-vdom')({ VNode, VText });


export {
    Dictionary,
    Mutator,
    htmlToVdom,
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/types/rendering.ts